export const ACTIVE_ROLE_QUERY_PARAM = "hd-activerole";

const ABSOLUTE_URL_REGEX = /^(https?:)?\/\//i;

export const appendActiveRoleToUrl = (
  url: string,
  roleId: number | string | null | undefined
): string => {
  if (!url || roleId === null || roleId === undefined) return url;

  try {
    const isAbsoluteUrl = ABSOLUTE_URL_REGEX.test(url);
    const normalizedUrl = new URL(url, window.location.origin);
    normalizedUrl.searchParams.set(ACTIVE_ROLE_QUERY_PARAM, String(roleId));

    if (isAbsoluteUrl) {
      return normalizedUrl.toString();
    }

    return `${normalizedUrl.pathname}${normalizedUrl.search}${normalizedUrl.hash}`;
  } catch {
    return url;
  }
};
